export default "__VITE_ASSET__BENgYjuh__"